import { AbstractNode } from '@/orrm/model/index'
import { Builder, ToManyRelation } from 'coloquent'
import { Layer } from '@/orrm/model/layer'
import { Entity } from '@/orrm/model/entity'

export class Context extends AbstractNode {
  protected jsonApiType = 'taxonomy_term/orrm_preset'

  static readonly context0uuid = 'no-context'

  static createContext0 (): Context {
    const context0 = new Context()

    context0.setApiId(Context.context0uuid)
    context0.setAttribute('name', 'Sans contexte')
    context0.setRelation('field_orrm_couches_carto', [])
    return context0
  }

  static getQueryBuilder (): Builder<Context> {
    return Context
      .with('field_orrm_couches_carto')
      .with('field_orrm_couches_carto.field_orrm_phenomene')
      .with('field_orrm_couches_carto.field_orrm_thematique')
      .with('field_orrm_couches_carto.field_orrm_public') as Builder<Context>
  }

  get name (): string {
    return this.getAttribute('name')
  }

  field_orrm_couches_carto (): ToManyRelation<Layer, this> { // eslint-disable-line
    return this.hasMany(Layer)
  }

  // field_orrm_entites_carto (): ToManyRelation<Entity, this> { // eslint-disable-line
  //   return this.hasMany(Entity)
  // }

  getLayers (): Layer[] {
    return this.getRelation('field_orrm_couches_carto')
  }

  getEntities (): Entity[] {
    return this.getRelation('field_orrm_entites_carto')
  }
}
